var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.084 6.41634H11.9173V8.24967H10.084V6.41634ZM10.084 10.083H11.9173V15.583H10.084V10.083ZM11.0007 1.83301C5.94065 1.83301 1.83398 5.93967 1.83398 10.9997C1.83398 16.0597 5.94065 20.1663 11.0007 20.1663C16.0607 20.1663 20.1673 16.0597 20.1673 10.9997C20.1673 5.93967 16.0607 1.83301 11.0007 1.83301ZM11.0007 18.333C6.95815 18.333 3.66732 15.0422 3.66732 10.9997C3.66732 6.95717 6.95815 3.66634 11.0007 3.66634C15.0431 3.66634 18.334 6.95717 18.334 10.9997C18.334 15.0422 15.0431 18.333 11.0007 18.333Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/InfoOutlined.415d347bda7440b53c7721dfdc4a9c3f.svg";
export { ForwardRef as ReactComponent };